module.exports = __webpack_public_path__ + "img/house_overview-xs.a22390f2.jpg";